import {ChangeDetectionStrategy, Component, effect, input, signal} from "@angular/core"
import {MatTooltipModule} from "@angular/material/tooltip"
import {fullName} from "@common/helpers/utils/user"
import {NextActor} from "@generated"
import {NextActorLabels, StateLabel} from "@labels"
import {UserThumbnailComponent} from "@platform/components/users/user-thumbnail/user-thumbnail.component"

export type AssignUserData = {
    id: string
    firstName?: string | null
    lastName?: string | null
    galleryImage?: {id: string} | null
}

@Component({
    selector: "cm-assign-user",
    templateUrl: "./assign-user.component.html",
    styleUrls: ["./assign-user.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTooltipModule, UserThumbnailComponent],
})
export class AssignUserComponent {
    readonly $user = input<AssignUserData | undefined | null>(undefined, {alias: "user"})
    readonly $nextActor = input<NextActor | undefined>(undefined, {alias: "nextActor"})

    readonly $nextActorLabel = signal<StateLabel<NextActor> | undefined>(undefined)
    readonly $assignedUserName = signal<string | undefined>(undefined)

    constructor() {
        effect(() => {
            this.update()
        })
    }

    update() {
        const user = this.$user()
        this.$assignedUserName.set(user ? fullName(user) : undefined)
        const nextActor = this.$nextActor()
        this.$nextActorLabel.set(nextActor ? NextActorLabels.get(nextActor) : undefined)
    }
}
